import assets from './assets';

const getImageFromCode = (code) => assets[code];

export default getImageFromCode;
